import React from 'react';

const Login = ({ classes, className }) => {
  window.location.href = process.env.REACT_APP_DASHBOARD_URL;
  return (<></>);
};

export default Login;
